module.exports = __webpack_public_path__ + "img/data_downlod_txt2.63d88cf2.png";